<template>
  <van-dialog
    v-model:show="dialogShow"
    :title="t('wallet.deleteBankCard')"
    :message="dialogMessage"
    :confirm-button-text="t('wallet.confirm')"
    :cancel-button-text="t('wallet.cancel')"
    :show-cancel-button="true"
    class="deleteBankCardDialog"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  />
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface Props {
  show: boolean
}

// 构建弹窗消息内容
const dialogMessage = computed(() => {
  return t('wallet.deleteBankCardWarning')
})

interface Emits {
  (e: 'update:show', value: boolean): void
  (e: 'confirm'): void
  (e: 'cancel'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const dialogShow = ref(props.show)

watch(() => props.show, (newVal) => {
  dialogShow.value = newVal
})

watch(dialogShow, (newVal) => {
  emit('update:show', newVal)
})

const handleConfirm = () => {
  emit('confirm')
  dialogShow.value = false
}

const handleCancel = () => {
  emit('cancel')
  dialogShow.value = false
}
</script>

<style lang="scss">
.van-popup.van-popup--center.van-dialog.deleteBankCardDialog {
  background: #00554A;

  .van-dialog__header {
    color: #fff;
  }

  .van-dialog__message {
    color: #fff;
  }

  button::before {
    background: #00554A;
  }

  .van-button--default {
    background: #00554A;

    .van-button__text {
      color: #ADB1B0;
    }
  }

  .van-dialog__confirm {
    .van-button__text {
      color: #3FB565;
    }
  }
}
</style>

